const kOriginalSym : unique symbol = Symbol();

/** A proxy object that throws a customizable error when accessed.
 *  Used as a replacement for a real object (like a socket) to invalidate it.  */
export class Invalidated<T extends object> {
    private constructor(private readonly error: new (message: string) => Error,
                        private readonly message: string,
                        original: T) { this[kOriginalSym] = original;}

    toString() {return `[Invalidated object: ${this.message}]`;}
    fail() {throw new this.error(this.message);}

    private [kOriginalSym]: T;

    static of<T extends object>(original: T,
                                message: string,
                                error: new (message: string) => Error = Error): T {
        const invalidated = new Invalidated(error, message, original);
        return new Proxy(invalidated, {
            get: (target, property, _receiver) => {
                switch (property) {
                    case 'toString':    return target.toString.bind(target);
                    case kOriginalSym:  return target[kOriginalSym];
                    default:            target.fail();
                }
            }
        }) as unknown as T;
    }

    static originalOf<T extends object>(inval: T): T | undefined {
        if (inval instanceof Invalidated)
            return inval[kOriginalSym] as T;
        else
            return undefined;
    }
}
